import { call } from '../utils/api';

class AppsService {
  fetchAll() {
    return call('app');
  }

  create(app) {
    return call('app', 'POST', app);
  }
}

export const appsService = new AppsService();



// WEBPACK FOOTER //
// ./src/services/appsService.js